export default __webpack_public_path__ + "static/media/advantages-02.0809f1b0.svg";